const actions = {
  async listCustomer(context, payload) {
    try {
      const response = await this.$api.call(
        "customer_management.listCustomer",
        payload,
      );
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationCustomers", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationCustomers", responseData);
      }

      context.commit("mutationCustomersMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationCustomers", []);
      context.commit("mutationCustomersMeta", {});

      throw error;
    }
  },

  async detailCustomer(context, payload) {
    try {
      const response = await this.$api.call(
        "customer_management.detailCustomer",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationCustomer", responseData);
      context.commit("mutationCustomerMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationCustomer", {});
      context.commit("mutationCustomerMeta", {});

      throw error;
    }
  },

  async listStatuses(context, payload) {
    try {
      const response = await this.$api.call(
        "customer_management.listStatus",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationStatuses", responseData);

      return response;
    } catch (error) {
      context.commit("mutationStatuses", []);

      throw error;
    }
  },

  async updateBankStatus(_context, payload) {
    try {
      const response = await this.$api.call(
        "customer_management.updateBankStatus",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async updateIDStatus(_context, payload) {
    try {
      const response = await this.$api.call(
        "customer_management.updateIDStatus",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
